import { runDemo } from "../shared/demoRunner";
import { createMotionBlurScene } from "./scene";

runDemo({ createScene: createMotionBlurScene });
